<template>
  <div class="achievement_gk">
    <!-- 业绩概况 -->
    <!-- nav -->
    <index-nav></index-nav>
     <!-- bottom -->
    <index-bottom></index-bottom>
    <div class="content">
      <!-- banner -->
      <div class="banner">
        <img src="/statics/images/info/yj_banner.jpg" alt />
      </div>
      <!-- 总导航 -->
      <div class="allnav inner">
        <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
          <el-tab-pane v-for="(item,index) in productCate" :key="index" :label="item.text" :name="index.toString()">
          </el-tab-pane>
          <!-- <el-tab-pane label="电厂系列产品" name="second"></el-tab-pane> -->
        </el-tabs>
      </div>
      <div class="yjCon inner">
        <!-- 单选 -->
        <div class="yj_select">
          <el-radio-group v-model="radio" @change="changeType" v-if="productCate.length!=0">
            <el-radio-button v-for="(item,index) in productCate[cateChild].children" :key="index" :label="item.value">
              {{item.text}}</el-radio-button>
            <!-- <el-radio-button label="2">电子</el-radio-button>
            <el-radio-button label="3">药业</el-radio-button>
            <el-radio-button label="4">食品</el-radio-button>
            <el-radio-button label="5">医院</el-radio-button>-->
          </el-radio-group>
        </div>
        <!-- 商品列表 -->
        <div class="picList">
          <div class="picitem" v-for="(item,index) in productList" :key="index">
            <img :src="adddom(item.thumb)" alt />
            <span>{{item.name}}</span>
          </div>
          <!-- <div class="picitem">
            <img src="/statics/images/info/yj_pic2.jpg" alt />
            <span>工程名称</span>
          </div>
          <div class="picitem last">
            <img src="/statics/images/info/yj_pic3.jpg" alt />
            <span>工程名称</span>
          </div>
          <div class="picitem">
            <img src="/statics/images/info/yj_pic4.jpg" alt />
            <span>工程名称</span>
          </div>
          <div class="picitem last">
            <img src="/statics/images/info/yj_pic5.jpg" alt />
            <span>工程名称</span>
          </div> -->
        </div>
      </div>
    </div>
    <!-- bottom -->
    <!-- <index-bottom></index-bottom> -->
    <!-- footer -->
    <index-footer></index-footer>
  </div>
</template>

<script>
  import indexNav from "./../components/nav";
  import indexBottom from "./../components/bottom";
  import indexFooter from "./../components/footer";
  export default {
    data() {
      return {
        cateChild: 0,
        activeName: "0",
        radio: "",
        productCate: [], //业绩概况
        productList: [] //列表
      };
    },
    components: {
      indexNav,
      indexBottom,
      indexFooter
    },
    created() {
      // 业绩分类
      this.getCate();
    },
    methods: {
      // 图片拼接地址
      adddom(src) {
        if (src == "" || src == undefined || src == null) {
          console.log("src地址有问题");
          return "";
        }
        if (src.substr(0, 4).toLowerCase() === "http") {
          return src;
        }
        return this.$url + src;
      },
      getCate() {
        var that = this;
        that.$api.index.productCate({}).then(function (res) {
          if (res.code == 200) {
            that.productCate = res.result;
            if (that.productCate && that.productCate[that.cateChild].children) {
              that.radio = that.productCate[
                that.cateChild
              ].children[0].value.toString();
              that.getList(that.radio);
            } else {
              that.productList = [];
            }
          }
        });
      },
      getList(cate_id) {
        var that = this;
        var ps = {
          cate_id: cate_id
          // page:1,
          // size:999
        };
        that.$api.index.productList(ps).then(function (res) {
          if (res.code == 200) {
            that.productList = res.result.list;
          }
        });
      },
      // 总导航选中触发
      handleClick(tab, event) {
        // console.log(tab, event);
        var that = this;
        that.cateChild = tab.name;
        if (that.productCate && that.productCate[that.cateChild].children) {
          that.radio = that.productCate[
            that.cateChild
          ].children[0].value.toString();
          that.getList(that.radio);
        } else {
          that.productList = []
        }
      },
      // 改变按钮
      changeType(e) {
        // console.log(e);
        this.getList(e);
      }
    },
    mounted: function () { }
  };
</script>

<style>
</style>